import { render, staticRenderFns } from "./AcademicCardsChapter.vue?vue&type=template&id=7c71f154&scoped=true"
import script from "./AcademicCardsChapter.vue?vue&type=script&lang=js"
export * from "./AcademicCardsChapter.vue?vue&type=script&lang=js"
import style0 from "./AcademicCardsChapter.vue?vue&type=style&index=0&id=7c71f154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c71f154",
  null
  
)

export default component.exports